// Simple global media stream manager to track and stop MediaStreams reliably
const streams = new Set<MediaStream>();

export function registerStream(s: MediaStream | null) {
  try {
    if (!s) return;
    streams.add(s);
    try { console.debug('[mediaManager] registerStream - stream id:', s.id, 'count:', streams.size); } catch (_) {}
  } catch (_) {}
}

export function unregisterStream(s: MediaStream | null) {
  try {
    if (!s) return;
    // stop tracks when unregistering to ensure hardware is released
    try { s.getTracks().forEach(t => { try { t.stop(); } catch (_) {} }); } catch (_) {}
    streams.delete(s);
    try { console.debug('[mediaManager] unregisterStream - stopped & removed stream id:', s.id, 'count:', streams.size); } catch (_) {}
  } catch (_) {}
}

export function stopStream(s: MediaStream | null) {
  try {
    if (!s) return;
    try { console.debug('[mediaManager] stopStream - stopping stream id:', s.id); } catch (_) {}
    try { s.getTracks().forEach(t => { try { t.stop(); } catch (_) {} }); } catch (_) {}
    streams.delete(s);
    try { console.debug('[mediaManager] stopStream - stream stopped id:', s.id, 'remaining:', streams.size); } catch (_) {}
  } catch (_) {}
}

export function stopAllStreams() {
  try {
    try { console.debug('[mediaManager] stopAllStreams - stopping all streams, count:', streams.size); } catch (_) {}
    streams.forEach(s => {
      try { s.getTracks().forEach(t => { try { t.stop(); } catch (_) {} }); } catch (_) {}
    });
    streams.clear();
    try { console.debug('[mediaManager] stopAllStreams - done, remaining count:', streams.size); } catch (_) {}
  } catch (_) {}
}

export default { registerStream, unregisterStream, stopStream, stopAllStreams };

// For debugging in the browser console, expose a small helper
try {
  if (typeof window !== 'undefined') {
    (window as any).__mediaManager = {
      stopAllStreams: () => { try { stopAllStreams(); } catch (e) { /* ignore */ } },
      listStreams: () => {
        try {
          return Array.from(streams).map(s => ({ id: s.id, tracks: s.getTracks().map(t=>({ kind: t.kind, enabled: t.enabled, label: t.label })) }));
        } catch (e) { return []; }
      }
    };
  }
} catch (_) {}
